/* Eyeshells collection toolbar cleanup v295
   Canonical behaviour for collection sort controls.
   - Removes fragile inline sort scripts
   - Keeps desktop dropdown lightweight
   - Uses mobile bottom-sheet on <= 767px
*/
(function(){
  if (window.__esCollectionToolbarCleanup) {
    try { window.__esCollectionToolbarCleanup(); } catch (e) {}
  }

  function isMobile(){
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function canHoverDesktop(){
    return !!(window.matchMedia && window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)').matches);
  }

  function ensureQueryParams(){
    window.Shopify = window.Shopify || {};
    Shopify.queryParams = Shopify.queryParams || {};
    if (location.search.length) {
      location.search.substr(1).split('&').forEach(function(pair){
        var kv = pair.split('=');
        if (kv.length > 1) {
          Shopify.queryParams[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        }
      });
    }
  }

  function getResponsiveSortLabel(text){
    if (!text) return '';
    var normalized = String(text).trim();
    if ((window.innerWidth || document.documentElement.clientWidth || 0) <= 389) {
      if (normalized === 'Price low to high') return 'Low to high';
      if (normalized === 'Price high to low') return 'High to low';
    }
    return normalized;
  }

  function syncDropdownState(dropdown, value){
    if (!dropdown || !value) return;
    var activeLink = dropdown.querySelector('.sort-item > a[href="' + value + '"]');
    var activeText = activeLink ? activeLink.querySelector('.sort-text') : null;
    dropdown.querySelectorAll('.sort-item').forEach(function(item){
      var link = item.querySelector('a');
      var active = !!link && link.getAttribute('href') === value;
      item.classList.toggle('active', active);
      if (link) link.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    var label = dropdown.querySelector('.dropdown-label');
    if (label && activeText) {
      var fullText = activeText.textContent.trim();
      label.textContent = getResponsiveSortLabel(fullText);
      label.setAttribute('data-es-full-label', fullText);
      label.setAttribute('title', fullText);
    }
  }

  function syncAllFromMarkup(){
    document.querySelectorAll('.collection-sorting .dropdown').forEach(function(dropdown){
      var active = dropdown.querySelector('.sort-item.active > a');
      if (active) syncDropdownState(dropdown, active.getAttribute('href'));
    });
  }



  function normalizeFilterIcons(){
    document.querySelectorAll('.filter_sortby .filter .es-filter-ico, .filter_sortby .filter .es-filter-ico path').forEach(function(node){
      try {
        node.style.setProperty('color', '#111', 'important');
        node.style.setProperty('stroke', '#111', 'important');
        node.style.setProperty('fill', 'none', 'important');
        node.style.setProperty('opacity', '1', 'important');
        node.style.setProperty('visibility', 'visible', 'important');
      } catch (e) {}
    });
  }

  function closeAll(){
    document.querySelectorAll('.collection-sorting .dropdown.es-mobile-sheet-open, .collection-sorting .dropdown.es-sort-open').forEach(function(dropdown){
      dropdown.classList.remove('es-mobile-sheet-open');
      dropdown.classList.remove('es-sort-open');
      var button = dropdown.querySelector('.dropdown-toggle');
      var sheet = dropdown.querySelector('.es-mobile-sort-sheet');
      if (button) button.setAttribute('aria-expanded', 'false');
      if (sheet) sheet.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('body > .collection-sorting.es-mobile-sort-portal-host').forEach(function(el){
      try { el.remove(); } catch (e) { if (el.parentNode) el.parentNode.removeChild(el); }
    });
    document.documentElement.classList.remove('es-mobile-sort-sheet-active');
    document.body.classList.remove('es-mobile-sort-sheet-active');
    document.body.classList.remove('es-sort-open-desktop');
  }

  function openDropdown(dropdown){
    if (!dropdown) return;
    closeAll();
    var button = dropdown.querySelector('.dropdown-toggle');
    if (isMobile()) {
      dropdown.classList.add('es-mobile-sheet-open');
      var sheet = dropdown.querySelector('.es-mobile-sort-sheet');
      if (button) button.setAttribute('aria-expanded', 'true');
      if (sheet) sheet.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('es-mobile-sort-sheet-active');
      document.body.classList.add('es-mobile-sort-sheet-active');
      document.body.classList.remove('es-sort-open-desktop');
      if (button && typeof button.blur === 'function') {
        window.setTimeout(function(){ try { button.blur(); } catch (e) {} }, 0);
      }
    } else {
      dropdown.classList.add('es-sort-open');
      document.body.classList.add('es-sort-open-desktop');
      if (button) button.setAttribute('aria-expanded', 'true');
    }
  }

  function onCaptureClick(e){
    var toggle = e.target && e.target.closest ? e.target.closest('.collection-sorting .dropdown-toggle') : null;
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var dropdown = toggle.closest('.dropdown');
      var openClass = isMobile() ? 'es-mobile-sheet-open' : 'es-sort-open';
      if (dropdown && dropdown.classList.contains(openClass)) closeAll();
      else openDropdown(dropdown);
      return;
    }


    var closeBtn = e.target && e.target.closest ? e.target.closest('[data-es-mobile-sort-close]') : null;
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      closeAll();
      return;
    }

    var insideDropdown = e.target && e.target.closest ? e.target.closest('.collection-sorting .dropdown') : null;
    if (!insideDropdown) closeAll();
  }

  function onBubbleClick(e){

    var link = e.target && e.target.closest ? e.target.closest('.collection-sorting .sort-item > a') : null;
    if (!link) return;
    var dropdown = link.closest('.dropdown');
    var value = link.getAttribute('href');
    if (!dropdown || !value) return;
    window.setTimeout(function(){
      syncDropdownState(dropdown, value);
      closeAll();
    }, 0);
  }

  function onKeydown(e){
    if (e.key === 'Escape' || e.key === 'Esc') { closeAll(); }
  }

  function onViewportChange(){
    closeAll();
    syncAllFromMarkup();
  }

  function initLegacySelects(){
    if (!window.ES_jqReady) return;
    window.ES_jqReady(function($){
      ensureQueryParams();
      $('#SortBy')
        .off('change.esCollectionToolbarClean')
        .on('change.esCollectionToolbarClean', function(){
          Shopify.queryParams.sort_by = $(this).val();
          location.search = $.param(Shopify.queryParams);
        });
      $('#showby')
        .off('change.esCollectionToolbarClean')
        .on('change.esCollectionToolbarClean', function(){
          Shopify.queryParams.view = $(this).val();
          location.search = $.param(Shopify.queryParams);
        });
    });
  }

  document.addEventListener('click', onCaptureClick, true);
  document.addEventListener('click', onBubbleClick, false);
  document.addEventListener('keydown', onKeydown, false);
  window.addEventListener('resize', onViewportChange, { passive: true });
  window.addEventListener('orientationchange', onViewportChange, { passive: true });
  closeAll();
  syncAllFromMarkup();
  normalizeFilterIcons();
  initLegacySelects();

  window.__esCollectionToolbarCleanup = function(){
    document.removeEventListener('click', onCaptureClick, true);
    document.removeEventListener('click', onBubbleClick, false);
    document.removeEventListener('keydown', onKeydown, false);
    window.removeEventListener('resize', onViewportChange, { passive: true });
    window.removeEventListener('orientationchange', onViewportChange, { passive: true });
    if (window.jQuery) {
      window.jQuery('#SortBy').off('change.esCollectionToolbarClean');
      window.jQuery('#showby').off('change.esCollectionToolbarClean');
    }
    closeAll();
    
  };
})();
